import { Phone, MessageCircle, MapPin } from "lucide-react";
import { BUSINESS } from "@/lib/constants";
import { useContent } from "@/lib/content";

const DEFAULT_ITEMS = [
  "FASTag Issuance",
  "Instant Recharge Assistance",
  "Activation & Replacement",
  "Delivery across 23 WB Districts",
  "Commercial Vehicle Support",
];

export default function AnnouncementBar() {
  const content = useContent();
  const settings = content?.settings || {};
  if (settings.announcement_bar_enabled === false) return null;

  const items = (content?.announcements && content.announcements.length > 0)
    ? content.announcements.map(a => a.text)
    : DEFAULT_ITEMS;
  const strip = [...items, ...items];
  const phone = settings.phone || BUSINESS.phone;
  const phoneDisplay = settings.phone_display || BUSINESS.phoneDisplay;
  const whatsapp = settings.whatsapp || BUSINESS.whatsapp;
  return (
    <div className="w-full bg-[#0057B8] text-white text-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center gap-6">
        <div className="hidden md:flex items-center gap-2 text-white/90 shrink-0">
          <MapPin className="w-4 h-4 text-[#F59E0B]" />
          <span>Bally Toll Plaza, Howrah</span>
        </div>
        <div className="overflow-hidden flex-1">
          <div className="marquee-track flex gap-8 whitespace-nowrap font-medium">
            {strip.map((t, i) => (
              <span key={i} className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-[#F59E0B] rounded-full" />
                {t}
              </span>
            ))}
          </div>
        </div>
        <div className="hidden sm:flex items-center gap-3 shrink-0">
          <a
            href={`tel:${phone}`}
            className="flex items-center gap-1.5 hover:text-[#F59E0B] transition-colors duration-200"
            data-testid="announcement-call"
          >
            <Phone className="w-4 h-4" />
            {phoneDisplay}
          </a>
          <a
            href={`https://wa.me/${whatsapp}`}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-1.5 hover:text-[#F59E0B] transition-colors duration-200"
            data-testid="announcement-whatsapp"
          >
            <MessageCircle className="w-4 h-4" />
            WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
}
